import DocumentsQueryFilter from "./documents-query-filter";
import { equal } from "../utils";
import IFilterResult from "../interface/filter-result";
import IDocumentsQuery from "../interface/documents-query";
import IDocument from "../interface/document";
import FieldType from "../enum/field-type";

export default class DocumentsQuery implements IDocumentsQuery {

    public filters: DocumentsQueryFilter[] = [];

    public fields: number[] = [];

    public ids: number[] = [];

    public noLF: boolean = false;

    constructor(params: IDocumentsQuery) {
        if (params.filters && params.filters.length) {
            params.filters.forEach(filter => this.filters.push(new DocumentsQueryFilter(filter)));
        }
        if (params.fields && params.fields.length) {
            this.fields = params.fields;
        }
        if (params.ids && params.ids.length) {
            this.ids = params.ids;
        }
        if (typeof params.noLF === 'boolean') {
            this.noLF = params.noLF;
        }
    }

    public toString(): string {
        let result: string[] = [];
        let filters: string[] = [];
        if (this.noLF) {
            result.push('noLF');
        }
        if (this.ids.length) {
            filters.push(`id in (${this.ids.join(',')})`);
        }
        if (this.filters.length) {
            filters = filters.concat(this.filters.map(filter => filter.toString()));
        }
        if (filters.length) {
            result.push(`q=${filters.join('&')}`);
        }
        if (this.fields.length) {
            result.push(`p=${this.fields.map(field => `c${field}`).join(',')}`);
        }
        return result.join('&');
    }

    public testDocuments(documents: IDocument[]): IFilterResult {
        const result: IFilterResult = {};
        documents.forEach((doc: IDocument) => result[doc.id as number] = this.testDocument(doc));
        return result;
    }

    private testDocument(doc: IDocument): boolean {
        let result = true;
        if (this.ids.length) {
            result = this.ids.indexOf(doc.id as number) > -1;
        }
        if (result) {
            if (this.filters.length) {
                this.filters.forEach((filter: DocumentsQueryFilter) => {
                    if (filter.field.uiType === FieldType.pointer) {
                        result = result && equal(doc[`c${filter.fieldId}`], [filter.value as number]);
                    }
                });
            }
        }
        return result;
    }

}